// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompaniesList-styles___pageHeaderWrapper--jfaK9 {
  display: flex;
  justify-content: space-between;
}

.components-CompaniesList-styles___clickable--jMBUu {
  cursor: pointer;
}

.components-CompaniesList-styles___tableHead--lPrFe {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-CompaniesList-styles___tableHead--lPrFe:first-child {
    width: 30%;
  }

.components-CompaniesList-styles___tableRow--YMsfP:last-child .components-CompaniesList-styles___tableRowCell--lvG_U {
      border: none;
    }

.components-CompaniesList-styles___tableRow--YMsfP:hover {
    background: #f6f6f7;
  }

.components-CompaniesList-styles___paper--tXTd7 {
  position: relative;
}

.components-CompaniesList-styles___tableRowCell--lvG_U {
  padding: 4px 24px 4px 24px !important;
  font-size: 15px !important;
  max-width: 220px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-CompaniesList-styles___tableRowCellEmail--PXv4i {
  max-width: 300px !important;
}

.components-CompaniesList-styles___tableRowCellBirthDate--VpFow {
  max-width: 70px !important;
}

.components-CompaniesList-styles___clickable--jMBUu {
  cursor: pointer;
}

.components-CompaniesList-styles___searchField--vcs0J {
  background-color: #fff;
  min-width: 300px !important;
}

.components-CompaniesList-styles___button--o60at {
  width: 20px;
  height: 20px;
}

.components-CompaniesList-styles___addCompany--Kp_p3 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #1e8aff !important;
  font-size: 13px;
  cursor: pointer;
}

.components-CompaniesList-styles___addCompany--Kp_p3:hover {
    color: #f6f6f7;
  }

.components-CompaniesList-styles___addIcon--xRrLE {
  height: 18px;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./components/CompaniesList/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAI5B;;AAHE;IACE,UAAU;EACZ;;AAKE;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;AAIjB;;AAHE;IACE,cAAc;EAChB;;AAEF;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n  &:first-child {\n    width: 30%;\n  }\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.paper {\n  position: relative;\n}\n\n.tableRowCell {\n  padding: 4px 24px 4px 24px !important;\n  font-size: 15px !important;\n  max-width: 220px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tableRowCellEmail {\n  max-width: 300px !important;\n}\n\n.tableRowCellBirthDate {\n  max-width: 70px !important;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.searchField {\n  background-color: #fff;\n  min-width: 300px !important;\n}\n\n.button {\n  width: 20px;\n  height: 20px;\n}\n\n.addCompany {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  color: #1e8aff !important;\n  font-size: 13px;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n}\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-CompaniesList-styles___pageHeaderWrapper--jfaK9`,
	"clickable": `components-CompaniesList-styles___clickable--jMBUu`,
	"tableHead": `components-CompaniesList-styles___tableHead--lPrFe`,
	"tableRow": `components-CompaniesList-styles___tableRow--YMsfP`,
	"tableRowCell": `components-CompaniesList-styles___tableRowCell--lvG_U`,
	"paper": `components-CompaniesList-styles___paper--tXTd7`,
	"tableRowCellEmail": `components-CompaniesList-styles___tableRowCellEmail--PXv4i`,
	"tableRowCellBirthDate": `components-CompaniesList-styles___tableRowCellBirthDate--VpFow`,
	"searchField": `components-CompaniesList-styles___searchField--vcs0J`,
	"button": `components-CompaniesList-styles___button--o60at`,
	"addCompany": `components-CompaniesList-styles___addCompany--Kp_p3`,
	"addIcon": `components-CompaniesList-styles___addIcon--xRrLE`
};
module.exports = ___CSS_LOADER_EXPORT___;
